import type { IIntervalService, IScope } from "angular";
import { isEmpty } from "lodash";
import { finalize } from "rxjs/operators";

import type { IAccountRepository } from "App/Modules/Auth";
import type { IResponseWithLoading } from "App/Modules/Models";
import { extendWithLoadingAndFail } from "../../../../Services/ObservableExtensions";

const defaultTimeout = 15;

export class RequestPasswordResetComponentController {
    public static $inject: string[] = ["$scope", "mmAccountRepository", "$interval"];

    public email: string;

    public requestResetResponse: IResponseWithLoading<void>;

    public requestTimeout = 0;

    public attempts = 0;

    constructor(
        private readonly $scope: IScope,
        private readonly accountRepository: IAccountRepository,
        private readonly $interval: IIntervalService,
    ) {}

    public requestPasswordReset() {
        if (!isEmpty(this.email)) {
            this.attempts++;

            extendWithLoadingAndFail(this.accountRepository.requestPasswordReset(this.email))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response: IResponseWithLoading<void>) => {
                        this.requestResetResponse = response;

                        if (!this.requestResetResponse.isLoading && this.attempts > 1) {
                            this.requestTimeout = defaultTimeout * this.attempts;

                            const interval = this.$interval(() => {
                                if (this.requestTimeout === 0) {
                                    this.$interval.cancel(interval);
                                }

                                this.requestTimeout--;
                            }, 1000);
                        }
                    },
                    (error) => {
                        this.requestResetResponse = error;
                    },
                );
        }
    }
}
